/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PartnerAttribution,
} from '../models/index';
import {
    PartnerAttributionFromJSON,
    PartnerAttributionToJSON,
} from '../models/index';

export interface GetPartnerAttributionsByCompanyIdRequest {
    companyId: number;
}

export interface GetPartnerAttributionsByPartnerIdRequest {
    partnerId: number;
}

export interface GetPartnerAttributionsByUserIdRequest {
    userId: number;
}

/**
 * 
 */
export class PartnerAttributionApi extends runtime.BaseAPI {

    /**
     * Get partnerAttributions by companyId
     */
    async getPartnerAttributionsByCompanyIdRaw(requestParameters: GetPartnerAttributionsByCompanyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerAttribution>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getPartnerAttributionsByCompanyId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner_attribution/company/{companyId}`;
        urlPath = urlPath.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerAttributionFromJSON));
    }

    /**
     * Get partnerAttributions by companyId
     */
    async getPartnerAttributionsByCompanyId(requestParameters: GetPartnerAttributionsByCompanyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerAttribution>> {
        const response = await this.getPartnerAttributionsByCompanyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partnerAttributions by partnerId
     */
    async getPartnerAttributionsByPartnerIdRaw(requestParameters: GetPartnerAttributionsByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerAttribution>>> {
        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling getPartnerAttributionsByPartnerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner_attribution/partner/{partnerId}`;
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerAttributionFromJSON));
    }

    /**
     * Get partnerAttributions by partnerId
     */
    async getPartnerAttributionsByPartnerId(requestParameters: GetPartnerAttributionsByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerAttribution>> {
        const response = await this.getPartnerAttributionsByPartnerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partnerAttributions by userId
     */
    async getPartnerAttributionsByUserIdRaw(requestParameters: GetPartnerAttributionsByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerAttribution>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getPartnerAttributionsByUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner_attribution/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerAttributionFromJSON));
    }

    /**
     * Get partnerAttributions by userId
     */
    async getPartnerAttributionsByUserId(requestParameters: GetPartnerAttributionsByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerAttribution>> {
        const response = await this.getPartnerAttributionsByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
